import { FC } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";

import JourneyCard from "../../Common/Card/Journey";
import { SUB_PAGES } from "../../../../interfaces/RegionalPage";

interface Props {
  items: SUB_PAGES[];
}

const DiscoverJourneyDesktopSlider: FC<Props> = ({ items }) => {
  return (
    <Splide
      options={{
        arrows: true,
        pagination: false,
        width: "100%",
        perPage: 4,
        type: "slide",
        rewind: false,
        autoplay: false,
        pauseOnHover: false,
        resetProgress: false,
        gap: "23px",
        interval: 5000,
        breakpoints: {
          1024: {
            perPage: 3,
          },
          768: {
            perPage: 2,
          },
          480: {
            perPage: 1,
          },
        },
      }}
    >
      {items.length > 0 &&
        items.map((item) => {
          return (
            <SplideSlide key={item.id}>
              <JourneyCard journey={item} />
            </SplideSlide>
          );
        })}
    </Splide>
  );
};
export default DiscoverJourneyDesktopSlider;
